
import { defineComponent, SetupContext, computed } from "vue";
import NativeClient from "@/client/native-client";

export default defineComponent({
  name: "FridgeDetailsMyAssistListItem",
  props: {
    /** 添字 */
    index: {
      type: Number,
      required: true
    },
    /** 名前 */
    name: {
      type: String,
      required: true
    },
    /** モード */
    mode: {
      type: String,
      required: true
    },
    /** 設定値 */
    settingTime: {
      type: String,
      required: true
    },
    /** 編集モード */
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context: SetupContext) {

    // タイトルの幅
    const styleTitle = computed(() => {
      if(props.isEditMode) {
        return { width: 'calc(100% - 20.4rem)' };
      }
      return { width: 'calc(100% - 14.8rem)' };
    });
 
    let isDeleteTouching = false;
    const clickItem = () => {
      if (!isDeleteTouching) {
        NativeClient.sendDebugLog("FridgeDetailsMyAssistListItem clickItem");
        context.emit("click-item", props.index);
      }
    };
    const clickItemDelete = () => {
      NativeClient.sendDebugLog("FridgeDetailsMyAssistListItem clickItemDelete");
      //context.emit("click-delete-item", props.index, props.name);
    };
    const deleteTouchStart = (event: TouchEvent) => {
      NativeClient.sendDebugLog("FridgeDetailsMyAssistListItem deleteTouchStart");
      isDeleteTouching = true;
      event.stopPropagation();
      event.preventDefault();
    };
    const deleteTouchMove = (event: TouchEvent) => {
      NativeClient.sendDebugLog("FridgeDetailsMyAssistListItem deleteTouchMove");
      isDeleteTouching = true;
      event.stopPropagation();
      event.preventDefault();
    };
    const deleteTouchCancel = (event: TouchEvent) => {
      NativeClient.sendDebugLog("FridgeDetailsMyAssistListItem deleteTouchCancel");
      isDeleteTouching = false;
      event.stopPropagation();
      event.preventDefault();
    };
    const deleteTouchEnd = (event: TouchEvent) => {
      NativeClient.sendDebugLog("FridgeDetailsMyAssistListItem deleteTouchEnd");
      isDeleteTouching = false;
      event.stopPropagation();
      context.emit("click-delete-item", props.index, props.name);
    };
    const stylePaddingRight = computed(() => {
      if (props.isEditMode) {
        return { paddingRight: "0" };
      }
      return { paddingRight: "1.6rem" };
    });

    return {
      styleTitle,
      clickItem,
      clickItemDelete,
      deleteTouchStart,
      deleteTouchMove,
      deleteTouchCancel,
      deleteTouchEnd,
      stylePaddingRight
    };
  }
});
